/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MachineType } from './MachineType';
import {
    MachineTypeFromJSON,
    MachineTypeFromJSONTyped,
    MachineTypeToJSON,
} from './MachineType';
import type { MachinePart } from './MachinePart';
import {
    MachinePartFromJSON,
    MachinePartFromJSONTyped,
    MachinePartToJSON,
} from './MachinePart';

/**
 * 
 * @export
 * @interface Machine
 */
export interface Machine {
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    yearBuild?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    serialNumber?: string;
    /**
     * 
     * @type {MachineType}
     * @memberof Machine
     */
    machineType?: MachineType;
    /**
     * 
     * @type {Array<MachinePart>}
     * @memberof Machine
     */
    parts?: Array<MachinePart>;
    /**
     * 
     * @type {Date}
     * @memberof Machine
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Machine
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Machine
     */
    active?: boolean;
}

/**
 * Check if a given object implements the Machine interface.
 */
export function instanceOfMachine(value: object): value is Machine {
    return true;
}

export function MachineFromJSON(json: any): Machine {
    return MachineFromJSONTyped(json, false);
}

export function MachineFromJSONTyped(json: any, ignoreDiscriminator: boolean): Machine {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'yearBuild': json['yearBuild'] == null ? undefined : json['yearBuild'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'machineType': json['machineType'] == null ? undefined : MachineTypeFromJSON(json['machineType']),
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(MachinePartFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachineToJSON(value?: Machine | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'location': value['location'],
        'imageUrl': value['imageUrl'],
        'yearBuild': value['yearBuild'],
        'serialNumber': value['serialNumber'],
        'machineType': MachineTypeToJSON(value['machineType']),
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(MachinePartToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

